// extracted by mini-css-extract-plugin
module.exports = {"menu__box--on_top":"Header_menu__box--on_top__1BUG9"};